import ErrorModal from './ErrorModal';

export interface OrderValidationFailedModalProps {
  message: string;
}

export default function OrderValidationFailedModal({ message }: OrderValidationFailedModalProps) {
  return <ErrorModal title="Beställning misslyckades!" message={message} />;
}
